<div class="page-header">
  <div class="page-container">
    <div class="page-header__content">
      <div class="page-header__info">
        <h2 class="page-header__title">Članovi Porodice</h2>
        <span class="page-header__subtitle">Članovi Porodice</span>
      </div>

      <div class="page-header__actions">
        <!-- <button nz-button [nzType]="'primary'" (click)="new()">
          Novi Član
        </button> -->
      </div>
    </div>
  </div>
</div>

<div class="page-container">
  <div class="page-content">
    <div class="mb-3 d-flex justify-content-end">
      <button nz-button nzType="primary" (click)="exportToExcel()">
        <i class="far fa-file-excel mr-1"></i>
        Listu ispod u Excel export.
      </button>
    </div>
    <form (submit)="searchDonations()">
      <nz-input-group nzSearch [nzAddOnAfter]="suffixIconButton">
        <input style="width: 50%"
          type="text"
          nz-input

          [formControl]="searchQueryControl"
          [placeholder]="'searchDonations' | translate"
        />

        <input style="width: 20%; margin-left: 10px; margin-right: 10px;"
        type="text"
        nz-input
        [formControl]="fromQueryControl"
        [placeholder]="'fromYearex2012' | translate"
      />

      <input style="width: 20%"
      type="text"
      nz-input
      [formControl]="toQueryControl"
      [placeholder]="'toYearex2021' | translate"
    />

    <input style="width: 5%; margin-left: 5px;"  readonly
    type="text"
    nz-input
    [placeholder]="totalResults"
  />

    <span style="padding: 5px; font-weight: 600;"></span> 
      </nz-input-group>
      
      <ng-template #suffixIconButton>
        <button nz-button nzType="primary" nzSearch>
          <i class="far fa-search"></i>
        </button>
      </ng-template>
    </form>

    <nz-table
      class="mt-2"
      #basicTable
      [nzData]="data"
      [nzLoading]="isLoading"
      [nzFrontPagination]="false"
      [nzTotal]="tableData.total"
      [nzPageSize]="tableData.pageSize"
      [nzPageIndex]="tableData.page"
      (nzQueryParams)="tableParamsChanged($event)"
    >
      <thead>
        <tr>
          <!-- <th nzWidth="50px">ID</th> -->
          <th>Naziv Člana</th>
          <th>Predstavnik Porodice</th>
          <th>Broj telefona</th>
          <th>Biljeska</th>
          <th>Datum Rodjena</th>
          <th>Grad</th>
          <th>Naselje</th>
           <th>Telefon</th>
          <!-- <th>Sex</th> -->
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of basicTable.data">
          <!-- <td>{{ data.id }}</td> -->
          <td>
            <span
              nz-typography
              [nzEllipsis]="true"
              [nzExpandable]="true"
              [nzEllipsisRows]="2"
              style="width: 200px"
              >{{ data.name }}</span
            >
          </td>
          <td>
            <span
              nz-typography
              [nzEllipsis]="true"
              [nzExpandable]="true"
              [nzEllipsisRows]="2"
              >{{ data.representative }}</span
            >
          </td>
          <td>
            <span
              nz-typography
              [nzEllipsis]="true"
              [nzExpandable]="true"
              [nzEllipsisRows]="2"
              style="width: 100px"
              >{{ data.representativePhone }}</span
            >
          </td>
          <td>
            <span
              nz-typography
              [nzEllipsis]="true"
              [nzExpandable]="true"
              [nzEllipsisRows]="2"
              >{{ data.note }}</span
            >
          </td>
          <td>
            <span
              nz-typography
              [nzEllipsis]="true"
              [nzExpandable]="true"
              [nzEllipsisRows]="2"
              >{{ data.dateOfBirth | date }}</span
            >
          </td>

          <td>
            <span
              nz-typography
              [nzEllipsis]="true"
              [nzExpandable]="true"
              [nzEllipsisRows]="2"
              >{{ data.city }}</span
            >
          </td>

          <td>
            <span
              nz-typography
              [nzEllipsis]="true"
              [nzExpandable]="true"
              [nzEllipsisRows]="2"
              >{{ data.residence }}</span
            >
          </td>

          
          <td>
            <span
              nz-typography
              [nzEllipsis]="true"
              [nzExpandable]="true"
              [nzEllipsisRows]="2"
              >{{ data.phone }}</span
            >
          </td>

          <!-- <td>
            <span
              nz-typography
              [nzEllipsis]="true"
              [nzExpandable]="true"
              [nzEllipsisRows]="2"
              style="width: 300px"
              >{{ data.sex }}</span
            >
          </td> -->

          <td class="text-right">
            <button nz-button nzSize="small" (click)="edit(data.id)">
              <i class="far fa-pen"></i>
            </button>

            <button
              nz-button
              nzSize="small"
              class="ml-2"
              (click)="delete(data.id)"
            >
              <i class="far fa-trash"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>
</div>
